import { atomWithStorage } from 'jotai/utils';
import { initWithStorage } from './jotai/initWithStorage';

const MODERN_LAYOUT_KEY = 'is-modern-layout';

export const isModernLayoutAtom = atomWithStorage(...initWithStorage(MODERN_LAYOUT_KEY, false));

export const ALLOW_MODERN_LAYOUT = import.meta.env.VITE_ENV !== 'PROD';

/** Set via VITE_FORCE_MODERN_LAYOUT=true in env-cmd (e.g., pnpm dev:modern) */
const FORCE_MODERN_LAYOUT = import.meta.env.VITE_FORCE_MODERN_LAYOUT === 'true';

export const getIsModernLayout = () => {
  if (FORCE_MODERN_LAYOUT) return true;
  try {
    if (!ALLOW_MODERN_LAYOUT) return false;
    const json = localStorage.getItem(MODERN_LAYOUT_KEY);
    return json ? JSON.parse(json) : false;
  } catch {
    return false;
  }
};
